import { Hub, Logger } from 'aws-amplify';
import { push } from 'connected-react-router';
import { sessionActions } from 'redux/modules/session';

const logger = new Logger('auth.listener');

export default (store) => {
  logger.onHubCapsule = (capsule) => {
    switch (capsule.payload.event) {
      case 'signIn':
        logger.info('user signed in');
        store.dispatch(push('/'));
        break;
      case 'signUp':
        logger.info('user signed up');
        store.dispatch(push('/'));
        break;
      case 'signOut':
        logger.info('user signed out');
        store.dispatch(push('/'));
        store.dispatch(sessionActions.logout());
        break;
    }
  };
  Hub.listen('auth', logger);
}
